import { HStack, Button, IconButton } from '@vimeo/bokeh';
import { Chats } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

import { useResizeObserver } from '../../hooks/use-resize-observer';

export interface EventActionBarProps {
  onJoinConversationClick?: () => void;
  showLiveTools?: boolean;
}

export const EventActionBar = ({ onJoinConversationClick, showLiveTools }: EventActionBarProps) => {
  const {
    ref: elementRef,
    dimension: { width },
  } = useResizeObserver<HTMLDivElement>();

  const showIconButtons = width < 480;

  return (
    <HStack ref={elementRef} gap={100} borderY="1px solid" borderColor="stroke" py={2}>
      {showIconButtons ? (
        showLiveTools ? (
          <IconButton
            aria-label={translate('Join the conversation')}
            variant="tertiary"
            size="sm"
            icon={<Chats />}
            onClick={onJoinConversationClick}
          />
        ) : null
      ) : showLiveTools ? (
        <Button
          aria-label={translate('Join the conversation')}
          onClick={onJoinConversationClick}
          variant="tertiary"
          size="sm"
          leftIcon={<Chats />}
        >
          {translate('Join the conversation')}
        </Button>
      ) : null}
    </HStack>
  );
};
